import { LowLatencyHostResponse } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type LowLatencyHostsParamName = 'filter'

const fetchLowLatencyHostsApi = async (
  args: FetchApiArgs<undefined, LowLatencyHostsParamName>
): Promise<FetchApiResponse<LowLatencyHostResponse>> => {
  const { signal } = args

  const data = await streamingRestApi.endpoints.lowLatencyHosts.getLowLatencyHosts(signal)

  return {
    content: data,
    totalElements: data.length
  }
}

export const useLowLatencyHostsStore = createBaseTableStore({
  storeName: 'Low Latency Hosts',
  fetchApi: fetchLowLatencyHostsApi
})
